import Pages from '../../../config/Pages';
import { permissionEnums } from '../../../core/enums/PermissionEnums';
import { Route } from '../../../core/utils/RouteMixins';
import Listar from './analisePropostaMeta/AnalisePropostaMeta';
import Form from './analisePropostaMetaForm/AnalisePropostaMetaForm';

const analisePropostaMetaRoutes = [
    Route(
        ['Analisar Proposta de Metas', 'pi pi-file-edit'],
        Pages.sei.analisePropostaMeta.url.list,
        Listar,
        [permissionEnums.ANALISE_PROPOSTA_META_VISUALIZAR]
    ),
    Route(null, Pages.sei.analisePropostaMeta.url.edit, Form, [
        permissionEnums.ANALISE_PROPOSTA_META_EDITAR,
    ]),
    Route(null, Pages.sei.analisePropostaMeta.url.view, Form, [
        permissionEnums.ANALISE_PROPOSTA_META_EDITAR,
    ]),
];

export default analisePropostaMetaRoutes;
